export default "/_next/static/18d92f413ab82e51dd3a9131c41abb81.png";